import twitter from 'twitter-text'
import { concatMentionsToEntities } from '../common'
import type { LinkedInAnnotationEntity } from '~publish/legacy/editor/plugins/linkedin-annotations/nodes/LinkedInAnnotationInputElement'

export const getLinkedInMentions = (
  liAnnotations?: LinkedInAnnotationEntity[] | null,
):
  | {
      displayString: string
      indices: [number, number]
      rawString: string
    }[]
  | null => {
  if (!liAnnotations || liAnnotations.length === 0) {
    return null
  }

  return liAnnotations.map((annotation) => {
    const { start } = annotation
    const end = start + annotation.length

    return {
      displayString: annotation.localizedName,
      indices: [start, end],
      rawString: annotation.localizedName,
    }
  })
}

const getEntities = (
  // @ts-expect-error TS(7006) FIXME: Parameter 'entities' implicitly has an 'any' type.
  entities,
  liAnnotations?: LinkedInAnnotationEntity[] | null,
) => {
  const mentions = getLinkedInMentions(liAnnotations)

  return concatMentionsToEntities(mentions, entities)
}

export function isOverlappingAnnotation(
  [start, end]: [number, number],
  liAnnotations: LinkedInAnnotationEntity[],
): boolean {
  return liAnnotations.some((annotation) => {
    const { start: annotationStart, length } = annotation
    const annotationEnd = annotationStart + length

    return start < annotationEnd && annotationStart < end
  })
}

export const parseLinkedInLinks = (
  text?: string | null,
  liAnnotations?: LinkedInAnnotationEntity[] | null,
) => {
  const entities = text
    ? twitter
        .extractEntitiesWithIndices(text)
        .map((entity) => {
          if (
            'url' in entity &&
            entity.url &&
            (!liAnnotations ||
              !isOverlappingAnnotation(entity.indices, liAnnotations))
          ) {
            return {
              displayString: entity.url,
              indices: entity.indices,
              rawString: entity.url,
              url: entity.url,
            }
          }
          if ('hashtag' in entity && entity.hashtag) {
            return {
              displayString: `#${entity.hashtag}`,
              indices: entity.indices,
              rawString: `#${entity.hashtag}`,
            }
          }
          return null
        })
        .filter((entity) => entity !== null)
    : []

  return getEntities(entities, liAnnotations)
}
